import { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'

import { useClient } from '../../hooks/useClient'

import StepMyPublication from './StepMyPublication'
import StepPublicationSuccess from './StepPublicationSuccess'

import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { XamaLogo } from '../../assets/svgs/icons'
import ModalComponent from '../../components/ModalComponent'

import ReactPlayer from 'react-player'

import { UserAccountsService } from '../../services'

const STEPS = {
  STEP_MY_PUBLICATION: 'stepMyPublication',
  STEP_PUBLICATION_SUCCESS: 'stepPublicationSuccess',
}

export default function NewPublicationPageMyPublication() {
  const { clientData } = useClient()
  const { t } = useTranslation()

  const location = useLocation()

  const [step, setStep] = useState(STEPS.STEP_MY_PUBLICATION)

  const [imageUrl, setImageUrl] = useState('')

  const publicationIdRef = useRef(undefined)

  const [oldPublicationMovie, setOldPublicationMovie] = useState(undefined)

  const [tutorialMovie, setTutorialMovie] = useState(false)

  useEffect(() => {
    if (location?.state?.data) {
      if (location?.state?.movie) {
        setOldPublicationMovie(location?.state?.data)
      }
    }
  }, [clientData])

  useEffect(() => {
    if (location?.state?.tutorialMovie) {
      setTutorialMovie(true)
    }
  }, [])

  return (
    <div className={styles.page}>
      {step === STEPS.STEP_MY_PUBLICATION && (
        <StepMyPublication
          setStep={setStep}
          publicationIdRef={publicationIdRef}
          imageUrl={imageUrl}
          setImageUrl={setImageUrl}
          clientData={clientData}
          oldPublicationMovie={oldPublicationMovie}
        />
      )}

      {step === STEPS.STEP_PUBLICATION_SUCCESS && (
        <StepPublicationSuccess
          imageUrl={imageUrl}
          publicationIdRef={publicationIdRef}
        />
      )}

      <ModalComponent
        isOpen={tutorialMovie}
        style={{
          width: '668px',
          borderRadius: '30px',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '60px ',
            gap: '10px',
          }}
        >
          <div>
            <XamaLogo width={108} height={32} />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '668px',
              textAlign: 'center',
            }}
          >
            <h1
              style={{
                fontSize: '26px',
                fontWeight: '400',
                padding: '0 60px',
                marginTop: '0px',
              }}
            >
              {
                t('first_publication_tutorial_video_popup.title')
              }
            </h1>
          </div>

          <div>
            <ReactPlayer
              style={{
                marginBottom: 20,
              }}
              url={
                'https://airenders.blob.core.windows.net/movies/79f6c95f-04d8-4cf9-87dd-716889e4e5e6.mp4'
              }
              controls
              width={530}
              height={298}
            />
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <div
              onClick={() => {
                setTutorialMovie(false)
                UserAccountsService.putUserAccountFirstOppenMyPost()
              }}
              style={{
                boxShadow: '0px 14px 40px 2px #6A009890',

                borderRadius: '40px',
              }}
            >
              <button
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '10px',
                  fontFamily: 'Poppins',
                  background:
                    'linear-gradient(156.31deg, #6A0098 0%, #9F00E4 100%)',
                  borderRadius: '40px',
                  fontSize: '16px',
                  fontWeight: '400',
                  padding: '12px 30px ',
                  boxShadow: '-3px 4px 13.9px 0px #FFFFFF59 inset',
                }}
              >
                {t('first_publication_tutorial_video_popup.button')}
              </button>
            </div>
          </div>
        </div>
      </ModalComponent>
    </div>
  )
}
